import { AppConfig } from "./config";

export const IS_DEV_MODE = AppConfig.AppStage === "dev";
export const CAPTCHA_ENABLED = !AppConfig.CaptchaDisabled && Boolean(AppConfig.CaptchaPublicKey);
